import ImageLayer from "../ImageLayer";
import { ClipArtLayerProps, ClipArtProps } from "./interfaces";
import { LayerCustomType } from "../../interfaces";

const DefaultClipArtSrc = "/images/default_clip_art.png";

export default class ClipArtLayer extends ImageLayer {
  protected static customType: LayerCustomType = LayerCustomType.ClipArt;
  protected static defaultImageSrc: string = DefaultClipArtSrc;
  protected static defaultTypeProps: Partial<ClipArtProps> = { optionId: 1 };

  name: string = "Clip art layer";
  clipArtProps: Partial<ClipArtProps>;

  constructor(options: Partial<ClipArtLayerProps> = {}) {
    const {
      transformSettings = {},
      typeSettings = {},
      ...layerProps
    } = options;
    super({ typeSettings });

    this.clipArtProps = { ...ClipArtLayer.defaultTypeProps, ...typeSettings };

    this.set(transformSettings);
    this.set(layerProps);
  }

  toObject() {
    const object = super.toObject();
    const clipArtProps = {
      ...(this.getClipArtProps() as ClipArtProps),
    };
    return { ...object, typeSettings: clipArtProps };
  }

  setClipArtProps(props: Partial<ClipArtProps>) {
    this.clipArtProps = { ...this.clipArtProps, ...props };
    this.rerender();
  }

  getClipArtProps(key?: keyof ClipArtProps) {
    if (key) {
      return this.clipArtProps?.[key];
    } else {
      return { ...this.clipArtProps };
    }
  }
}

export * from "./interfaces";
